import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

/**
 * Total de vagas por status (para os badges das colunas do kanban), numa única
 * query barata (RPC get_vagas_status_counts: GROUP BY status sobre vagas_base,
 * indexado — NÃO usa a view agregada). As 7 colunas chamam este hook com a mesma
 * key e o TanStack deduplica numa só request.
 */
export function useVagasCounts(agenciaId: string) {
  return useQuery({
    queryKey: ["vagas-counts", agenciaId],
    staleTime: 30_000,
    queryFn: async (): Promise<Record<string, number>> => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const { data, error } = await (supabase as any).rpc("get_vagas_status_counts", {
        p_agencia_id: agenciaId || null,
      });
      if (error) throw error;
      const map: Record<string, number> = {};
      for (const row of (data ?? []) as { status: string; total: number }[]) {
        map[row.status] = Number(row.total);
      }
      return map;
    },
  });
}
